var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #323232;\n      }\n\n      .cls-2 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.21,15.52v-1.08c0-.5-.41-.87-.91-.87h0c-.5,0-.91.37-.91.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.21,15.04c0-.5.41-.56.91-.56h0c.5,0,.91.41.91.91v.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.4,15.52v-3.37c0-.5-.34-1.08-.95-1.08h0c-.95,0-1.11.68-1.11,1.18v3.8s0,.98,0,.98l-.76-.79c-.37-.37-1.12-.55-1.71.05h0c-.31.31-.46.94.03,1.57l2.22,2.56c.67,1.01,1.81,1.62,3.02,1.62h1.08c2.01,0,3.63-1.63,3.63-3.63v-2.41c0-.5-.41-.91-.91-.91h0c-.5,0-.91.41-.91.91"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.03,12.75l-.2.04c-.41.09-.74.38-.87.78l-.06.2c-.28.85-1.38,1.08-1.98.41l-.14-.15c-.28-.31-.7-.45-1.11-.37l-.2.04c-.88.18-1.63-.65-1.35-1.51l.06-.2c.13-.4.04-.83-.24-1.14l-.14-.15c-.6-.67-.25-1.74.63-1.92l.2-.04c.41-.09.74-.38.87-.78l.06-.2c.28-.85,1.38-1.08,1.98-.41l.14.15c.28.31.7.45,1.11.37l.2-.04c.88-.18,1.63.65,1.35,1.51l-.06.2c-.13.4-.04.83.24,1.14l.14.15c.6.67.25,1.74-.63,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.19,9.6c-.48,0-.93.31-1.09.79-.2.6.13,1.25.73,1.45.12.04.24.06.36.06.48,0,.93-.31,1.09-.79.2-.6-.13-1.25-.73-1.45-.12-.04-.24-.06-.36-.06h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 14.5,
    cy: 7.92,
    r: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.43,13.85l1.77-.57c.28-.09.45-.37.4-.66l-.17-.99c-.03-.2.04-.39.18-.53.12-.12.24-.25.35-.38.13-.16.31-.25.51-.23l1,.07c.29.02.56-.18.62-.47l.39-1.81c.06-.29-.1-.58-.37-.68l-.94-.35c-.19-.07-.32-.23-.37-.42-.04-.17-.1-.33-.16-.5-.07-.19-.06-.39.05-.56l.56-.84c.16-.24.13-.57-.09-.77l-1.38-1.25c-.22-.2-.55-.2-.78-.02l-1.02.85c-.18-.06-.37-.12-.56-.16s-.39-.07-.58-.08l-.58-1.19c-.13-.27-.43-.4-.71-.3l-1.77.57c-.28.09-.45.37-.4.66l.17.99c.03.2-.04.39-.18.53-.12.12-.24.25-.35.39-.13.15-.31.25-.51.23l-1-.07c-.29-.02-.56.18-.62.47l-.39,1.81"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminCenter);
export default __webpack_public_path__ + "static/media/AdminCenter.cca2d2937b4f99c89ad5dc397e19c133.svg";
export { ForwardRef as ReactComponent };